import React from 'react';
import { Path, Rect, Circle, Line, Polygon, Polyline, Svg } from 'react-native-svg';
import type { IconProps } from './types';

export const LockIcon: React.FC<IconProps> = ({
  size = 16,
  color = '#020202',
  style,
  ...props
}) => (
  <Svg
    width={size}
    height={size}
    viewBox="0 0 16 18"
    fill="none"
    overflow="visible"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
    style={[{ overflow: 'visible' } as const, style] as unknown}
  >
    <Path
      d="M2 16.75H14V7.75H2V16.75ZM4.15217 4.38636C4.15217 2.27297 5.82057 0.75 8 0.75C10.1794 0.75 11.75 2.27297 11.75 4.38636V7.75H4.15217V4.38636ZM8 13.75C7.44772 13.75 7 13.3023 7 12.75V11.75C7 11.1977 7.44772 10.75 8 10.75C8.55228 10.75 9 11.1977 9 11.75V12.75C9 13.3023 8.55228 13.75 8 13.75Z"
      stroke="black"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Svg>
);

LockIcon.displayName = 'LockIcon';
